<template>
  <div>
    <b-row>
      <b-col cols="12">
        <branches-filter :get-report-data="getReport" />
      </b-col>
      <b-col
        v-if="loading"
        cols="12"
      >
        <loading-card />
      </b-col>
      <template v-else>
        <b-col
          cols="12"
        >
          <b-card title="Genel Toplam">
            <b-row>
              <b-col
                cols="12"
                md="4"
                class="mb-2"
              >
                <flat-card
                  title="Poliçe Adet"
                  :value="reportData.grandTotals.counts"
                  icon="UmbrellaIcon"
                  color="info"
                />
              </b-col>
              <b-col
                cols="12"
                md="4"
                class="mb-2"
              >
                <flat-card
                  title="Komisyon"
                  :value="reportData.grandTotals.komisyon"
                  icon="CheckCircleIcon"
                  suffix="₺"
                  color="success"
                />
              </b-col>
              <b-col
                cols="12"
                md="4"
                class="mb-2"
              >
                <flat-card
                  title="Net Prim"
                  :value="reportData.grandTotals.prim"
                  icon="InfoIcon"
                  suffix="₺"
                  color="info"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col cols="12">
          <insurance-mixed-charts
            :series-data="reportData.grandTotals.chartData.series"
            :categories-data="reportData.grandTotals.chartData.categories"
            :yaxis-data="reportData.grandTotals.chartData.yaxis"
            :title-text="reportData.grandTotals.chartData.chartTitle"
          />
        </b-col>
        <b-col
          v-for="item in reportData.data"
          :key="item.id"
          cols="12"
        >
          <b-card :title="item.bransadi">
            <b-row>
              <b-col
                cols="12"
                md="4"
                class="mb-2"
              >
                <flat-card
                  title="Poliçe Adet"
                  :value="item.counts"
                  icon="UmbrellaIcon"
                  color="info"
                />
              </b-col>
              <b-col
                cols="12"
                md="4"
                class="mb-2"
              >
                <flat-card
                  title="Komisyon"
                  :value="item.komisyon"
                  suffix="₺"
                  icon="CheckCircleIcon"
                  color="success"
                />
              </b-col>
              <b-col
                cols="12"
                md="4"
                class="mb-2"
              >
                <flat-card
                  title="Net Prim"
                  :value="item.prim"
                  suffix="₺"
                  icon="InfoIcon"
                  color="info"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </template>
    </b-row>
  </div>
</template>
<script>
import { BRow, BCol, BCard } from 'bootstrap-vue'
import FlatCard from '@/layouts/components/ReportCards/FlatCard.vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import BranchesFilter from '@/views/Insurance/FilterCards/BranchesFilter.vue'
import InsuranceMixedCharts from '@/layouts/components/ReportCharts/InsuranceMixedCharts.vue'

export default {
  name: 'BranchesInsurance',
  components: {
    BranchesFilter,
    LoadingCard,
    BRow,
    BCol,
    BCard,
    FlatCard,
    InsuranceMixedCharts,
  },
  computed: {
    filterParams() {
      return this.$store.getters['insuranceBranchesReports/filterParams']
    },
    reportData() {
      return this.$store.getters['insuranceBranchesReports/reportData']
    },
    loading() {
      return this.$store.getters['insuranceBranchesReports/loading']
    },
  },
  created() {
    this.getReport()
  },
  methods: {
    getReport() {
      this.$store.dispatch('insuranceBranchesReports/getReportData', this.filterParams)
    },
  },
}
</script>
